<template>
  <div
    v-if="cards.length"
    class="overflow-hidden rounded-xl border border-default bg-default shadow-sm"
  >
    <div class="grid grid-cols-2 gap-px bg-muted md:flex md:gap-0 md:divide-x md:divide-default md:bg-default">
      <div
        v-for="card in cards"
        :key="card.title"
        class="flex items-center justify-center gap-2 bg-default px-3 py-3 text-center [&:last-child:nth-child(odd)]:col-span-2 md:flex-1 md:gap-2.5 md:px-4"
      >
        <UIcon :name="card.icon" class="h-5 w-5 shrink-0 text-primary-600 dark:text-primary-400" />
        <span class="text-sm font-medium text-toned">{{ card.title }}</span>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
const { homepageFeatureCards } = useSiteSettings()

const cards = computed(() => homepageFeatureCards.value)
</script>
